import i18n from "../../public/lang/index"
import {
    Message
} from "element-ui"
let plugin = {
    install: (Vue) => {
        Vue.prototype.$error = (error) => {
            try {
                if (typeof (error) === "string") {
                    throw (error)
                } else if (typeof error === "object") {
                    if (error.status) {
                        switch (error.status) {
                            case 400:
                                throw (`${i18n.t("message.errorMessage.ClientException")}(${error.status})`)
                            case 401:
                                return
                                break
                            case 403:
                                return
                                break
                            case 404:
                                throw (`${i18n.t("message.errorMessage.ClientException")}(${error.status})`)
                                break
                            case 409:
                                return
                                break
                            case 500:
                                throw (`${i18n.t("message.errorMessage.ServerException")}(${error.status})`)
                            default:
                                throw (`${i18n.t("message.errorMessage.NetworkException")}(${error.status})`)
                        }
                    } else if (error.message) {
                        switch (error.message) {
                            case "Cannot read property 'data' of undefined":
                                throw (i18n.t("message.errorMessage.CheckNetwork"))
                            default:
                                throw (error)
                        }
                    }
                }
                throw (i18n.t("message.errorMessage.UnknownError"))
            } catch (error) {
                if (error.toString().indexOf('TypeError') != -1) {
                    return;
                } else {
                    Message.error({
                        message: error
                    });
                }
            }

        }
    }
}

export default plugin